import { LoadableTypography } from "@faire/retailer-visitor-shared/components/GhostLoading/LoadableTypography";
import { Row } from "@faire/web--source/slate/Layout";
import { cn } from "@faire/web--source/tools/cn";
import { NoTranslate } from "@faire/web--source/ui/lib/localization";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import React from "react";

import { BrandIcon } from "./BrandIcon";

interface IBrandNameTextProps {
  brandToken: string | undefined;
  brandName: string | undefined;
  brandIcon?: IFaireIcon | undefined;
  isLoaded: boolean;
  addUnderline?: boolean;
}

export const BrandNameText: React.FC<IBrandNameTextProps> = ({
  brandToken,
  brandName,
  brandIcon,
  isLoaded,
  addUnderline = true,
}) => {
  const brandNameSection = (
    <Row align="center">
      <BrandIcon brandIcon={brandIcon} />
      <LoadableTypography
        isLoaded={isLoaded}
        variant="paragraphSansRegular"
        maxLines={1}
        className="break-all"
      >
        <NoTranslate>
          <span>{brandName}</span>
        </NoTranslate>
      </LoadableTypography>
    </Row>
  );

  if (!brandToken) {
    return null;
  }
  return (
    <Row
      className={cn("overflow-hidden", { underline: addUnderline })}
      justify="space-between"
    >
      {brandNameSection}
    </Row>
  );
};
